import React from 'react';
import {tid} from '../../../../../testUtils';
import SubmitButton from '../../../../core/Buttons/SubmitButton';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ScenarioActionProps} from '../../../actionMenuTypes';
import useScenarioParametersExportToWord from './useScenarioParametersExportToWord';
import {DocumentWordProcessor16} from '@carbon/icons-react';

const ScenarioParametersExportToWordActionMenuButton: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const download = useScenarioParametersExportToWord(props);

  return (
    <SubmitButton
      onClick={download}
      type="button"
      endIcon={<DocumentWordProcessor16 />}
      {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_PARAMETERS_EXPORT_WORD)}
    >
      Export to Word
    </SubmitButton>
  );
};

export default ScenarioParametersExportToWordActionMenuButton;
